import { Button, Form, Modal } from "antd";
import Link from "antd/lib/typography/Link";
import { useContext, useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";

import ApiService from "../../Api.service";
import ApiUtils, { displayError } from "../../ApiUrls";
import FilterInput from "./FilterInput";
import { useHistory } from "react-router-dom";
import { displayFields } from "../Users/Users";
import { applicationSelectionColour } from "../MainLayout/MainHeader";

export default function FiltersModal(props) {
    const { getListByFilter, onFilterApply, onResetClick, advancedFilters, type, accounts, pageSize, statusTypes } = props;
    const history = useHistory()
    const initialFilterInput = { field: "", operator: "equals", value: "" };
    const [isVisible, setIsVisible] = useState(false);
    const [filterableFields, setFilterableFields] = useState<any>([]);
    const [filterInputs, setFilterInputs] = useState([initialFilterInput]);
    const [appliedFilterCount, setAppliedFilterCount] = useState(0);
    const pathname = window.location.pathname

    useEffect(() => {
        filterInputs.length === 0 && setFilterInputs([initialFilterInput])
    }, [filterInputs]);

    function setAdvancedFiltersToFilters() {
        if (advancedFilters) {
            if (Object.keys(advancedFilters).length === 0) {
                setAppliedFilterCount(0)
                setFilterInputs([initialFilterInput])
            }
            else {
                if (advancedFilters['filters']) {
                    setAppliedFilterCount(advancedFilters['filters'].filter(
                        (filterInput) =>
                            filterInput.field !== "" && filterInput.value !== "" && filterInput.operator !== ""
                    ).length)
                    setFilterInputs(advancedFilters['filters'].filter(
                        (filterInput) =>
                            filterInput.filter_on !== "" && filterInput.value !== "" && filterInput.operator !== ""
                    ).map((item) => {
                        return {
                            field: item.filter_on,
                            value: item.value,
                            operator: item.operator
                        }
                    }))
                }
            }
        }
    }

    useEffect(() => {
        setAdvancedFiltersToFilters()
    }, [advancedFilters])

    useEffect(() => {
        (async function () {
            var response = [];
            if (response.length === 0) {
                switch (type) {
                    case "users":
                        response = await ApiService.get(ApiUtils.userFilterableFields);
                        break;
                    default:
                        break;
                }

                if (response) {
                    if (displayError(response)) {
                        setFilterableFields(response)
                    }
                }
            }
        }
        )();
    }, []);

    const onFilterOptionChange = (field, index) => {
        setFilterInputs((state) => {
            const values = [...state];
            values[index].field = field;
            values[index].value = "";
            return values;
        });
    };

    const onFilterValueChange = (value, index) => {
        setFilterInputs((state) => {
            const values = [...state];
            values[index].value = value;
            return values;
        });
    };

    const onFilterOperatorChange = (value, index) => {
        setFilterInputs((state) => {
            const values = [...state];
            values[index].operator = value;
            return values;
        });
    };

    const validateFields = () => {
        const filteredAndUniqueInputs = filterInputs.filter(filterInput =>
            filterInput.field !== "" && filterInput.value !== ""
        )

        setFilterInputs(filteredAndUniqueInputs);
    }

    const removeInvalidFields = (action = 'apply') => {
        if (action === 'close') {
            setAdvancedFiltersToFilters()
        }
        else {
            validateFields()
        }
    }

    const onApplyFiltersClick = () => {
        console.log("jo")
        setIsVisible(false);
        const filteredAndUniqueInputs = filterInputs.filter(filterInput =>
            filterInput.field !== "" && filterInput.value !== ""
        )
        let finalFilterInputs = filteredAndUniqueInputs
        setFilterInputs([
            ...finalFilterInputs,
        ]);

        setAppliedFilterCount(
            finalFilterInputs.length
        );

        const optimisedFiltersObj = finalFilterInputs.map((filterInput) => {
            return { filter_on: filterInput.field, operator: filterInput.operator, value: filterInput.value };
        })
        let reducedOptimisedFiltersObj = {}
        if (optimisedFiltersObj.length !== 0) {
            reducedOptimisedFiltersObj = { filters: optimisedFiltersObj }
            onFilterApply(reducedOptimisedFiltersObj)
        }

        if (getListByFilter) {
            let advancedFiltersData: any = {};
            let start = 1;
            let limit = pageSize ?? 10;
            let params = { start: start, limit: limit }

            advancedFiltersData.params = params;
            advancedFiltersData.object = reducedOptimisedFiltersObj

            if (Object.keys(advancedFiltersData).length > 0) {
                history.push(pathname.split('?')[0] + `?filters=${encodeURIComponent(JSON.stringify(advancedFiltersData))}`)
            }
        }
    };

    function addFiltersToPathname() {
        if (getListByFilter) {
            let advancedFiltersData: any = {};
            let start, limit;
            if (window.location.search.includes('filters=')) {
                advancedFiltersData = JSON.parse(decodeURIComponent(window.location.search.split("filters=")[1]));
                start = advancedFiltersData.params.start
                limit = advancedFiltersData.params.limit
            }
            else {
                start = 1;
                limit = 10;
            }

            advancedFiltersData.params = { start: start, limit: limit }
            advancedFiltersData.object = {}
            history.push(pathname.split('?')[0] + `?filters=${encodeURIComponent(JSON.stringify(advancedFiltersData))}`)
        }
    }

    return (
        <div>
            <Button onClick={() => setIsVisible(true)} >
                Advanced Filters{" "}
                {appliedFilterCount !== 0 ? `(${appliedFilterCount})` : null}
            </Button>
            &nbsp;&nbsp;
            <Button
                onClick={() => {
                    if (appliedFilterCount > 0) {
                        setAppliedFilterCount(0);
                        setFilterInputs([initialFilterInput]);
                        onResetClick();
                    }
                    else if (["portalLogs", "products", 'ad-imports', 'token-rotation'].includes(type)) {
                        onResetClick();
                    }
                    addFiltersToPathname()
                }}
            >
                Clear Filters
            </Button>
            <Modal
                maskClosable={false}
                open={isVisible}
                onOk={() => setIsVisible(false)}
                onCancel={() => {
                    removeInvalidFields('close')
                    setIsVisible(false);
                }}
                title={<div className="common-modal-title">Advanced Filters</div>}
                className="advanced-filters-modal"
                style={{ minWidth: '700px', maxWidth: '1000px' }}
                closeIcon={<CloseOutlined className='ant-btn ant-btn-default ant-btn-icon-only' style={{ padding: '0.1rem' }} />}
                footer={false}
                width={'50vw'}
            >
                <Form onFinish={onApplyFiltersClick}>
                    <div style={{ marginBottom: '20px' }}>
                        <Button
                            onClick={() => {
                                if (appliedFilterCount > 0) {
                                    onResetClick();
                                    addFiltersToPathname()
                                }
                                setFilterInputs([initialFilterInput]);
                            }}
                        >
                            Clear
                        </Button>
                    </div>
                    <div className="advanced-filters">
                        {filterInputs.map((filterInput, index) => {
                            return <FilterInput
                                statusTypes={statusTypes}
                                accounts={accounts}
                                filtersCount={filterInputs.length}
                                key={index}
                                filterableFields={filterableFields}
                                filterInput={filterInput}
                                index={index}
                                onFilterFieldChange={(value) => onFilterOptionChange(value, index)}
                                onFilterOperatorChange={(value) => onFilterOperatorChange(value, index)}
                                onFilterValueChange={(value) => onFilterValueChange(value, index)}
                                onCloseClick={() => {
                                    setFilterInputs((state) => {
                                        const values = [...state];
                                        if (values.length > 1)
                                            values.splice(index, 1);
                                        return values;
                                    });
                                    setAppliedFilterCount(filterInputs.length)
                                }}
                                fieldLabels={displayFields}
                            />
                        })}
                    </div>
                    <Button
                        style={{ margin: "10px 0 10px 0" }}
                        onClick={() => {
                            setFilterInputs((state) => [
                                ...state,
                                initialFilterInput,
                            ]);
                        }}
                    >
                        Add Filter
                    </Button>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                        }}
                    >
                        <Button type="primary"
                            disabled={false}
                            className="font-size-14px"
                            htmlType="submit"
                        >
                            Apply Filters
                        </Button>
                        <Button
                            onClick={() => {
                                removeInvalidFields('close')
                                setIsVisible(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </Form>
            </Modal>
        </div>
    );
}
